export const handleDynamicImportError = (error: unknown): void => {
  if (error instanceof Error && error.message.includes("dynamically imported module")) {
    window.location.reload();
  }
};
